import { LanguageEnum } from '../enums';

export interface UserUpdateRequest {
  firstName: string;
  lastName: string;
  language?: LanguageEnum;
}

export namespace UserUpdateRequest {
  export function mapToApiValue({ language, ...restOfData }: UserUpdateRequest): any {
    return {
      ...restOfData,
      language: language && LanguageEnum.mapToApiValue(language),
    };
  }
}
